import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { TableOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';
import { ROUTE_NAMES } from '../names';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.sort 排序越小越排前
 *
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/topic-management',
    name: ROUTE_NAMES.TOPIC_MANAGEMENT,
    // redirect: '/list/basic-list',
    redirect: '/topic-management/topics',
    component: Layout,
    meta: {
      title: '话题管理',
      icon: renderIcon(TableOutlined),
      sort: 6,
    },
    children: [
      {
        path: 'topics',
        name: ROUTE_NAMES.TOPICS,
        meta: {
          title: '话题列表',
        },
        component: () => import('@/views/topic-management/index.vue'),
      },
      {
        path: 'topic-videos/:id?',
        name: ROUTE_NAMES.TOPIC_VIDEOS,
        meta: {
          title: '短视频列表',
          hidden: true,
          activeMenu: 'basic-list',
        },
        component: () => import('@/views/list/project/info.vue'),
      },
    ],
  },
];

export default routes;
